import React from 'react'
import PropTypes from 'prop-types'
import { cloneDeep, get, isEqual, split } from 'lodash'
import RemoteOptionsSelectField from './RemoteOptionsSelectField'
import SelectField from './SelectField'
import Component from './Component'
import Modal from './Modal'
import LabeledTextField from './LabeledTextField'
import DateRangeComponent from './DateRangeComponent'
import SubmitButton from './SubmitButton'

export default class IndexFilterModal extends Component {
  static propTypes = {
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func
    ]).isRequired,
    filterValues: PropTypes.object,
    filterActions: PropTypes.object,
    handleClose: PropTypes.func.isRequired,
    handleSelected: PropTypes.func.isRequired,
    remoteKey: PropTypes.string.isRequired,
    initialValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ])
  }

  constructor(props) {
    super(props)

    this.state = {
      value: props.initialValue,
      initialValue: cloneDeep(props.initialValue),
      close: false
    }
  }

  get selectField() {
    switch (get(this.props.filterValues, 'type')) {
    case 'dateField':
      return this.dateField
    case 'dateRangeField':
      return this.dateRangeField
    case 'standardSelectField':
      return this.standardSelectField
    default:
      return this.remoteSelectField
    }
  }

  get dateField() {
    const {
      remoteKey
    } = this.props

    return (
      <LabeledTextField
        label="Enter date to filter"
        name={remoteKey}
        key={remoteKey}
        handleChange={this.handleFilterChange}
        value={this.state.value}
        type="date"
      />
    )
  }

  get dateRangeField() {
    const {
      remoteKey
    } = this.props

    const [start, end] = split(this.state.value ?? '', '..', 2)

    return (
      <DateRangeComponent
        name={remoteKey}
        handleChange={this.handleDateRangeChange}
        value={{ start, end }}
      />
    )
  }

  get standardSelectField() {
    const {
      filterValues,
      remoteKey
    } = this.props

    return (
      <SelectField
        label="Enter text to filter"
        key={remoteKey}
        name={remoteKey}
        handleChange={this.handleFilterChange}
        value={this.state.value}
        options={filterValues.records}
        autoFocus
        multi
      />
    )
  }

  get remoteSelectField() {
    const {
      filterValues,
      filterActions,
      remoteKey
    } = this.props

    return (
      <RemoteOptionsSelectField
        label="Enter text to filter"
        placeholder="Type at least 2 characters to filter"
        key={remoteKey}
        name={remoteKey}
        handleChange={this.handleFilterChange}
        records={filterValues.records}
        requestInProgress={filterValues.requestInProgress}
        reset={filterActions.reset}
        recordsRequest={filterActions.records}
        recordValue="name"
        value={this.state.value}
        autoFocus
        multi
      />
    )
  }

  handleDateRangeChange = (name, value) => {
    this.setState({ value: `${value.start}..${value.end}` })
  }

  handleFilterChange = (name, value) => {
    this.setState({ value })
  }

  handleSelected = (event) => {
    this.setState({ close: true })

    this.props.handleSelected(this.props.remoteKey, this.state.value)
  }

  handleCancelButton = (event) => {
    this.setState({ close: true })
    this.props.handleClose()
  }

  render() {
    if (this.state.close) {
      return null
    }

    return (
      <Modal
        handleClose={this.handleCancelButton}
        className="filter-modal"
      >
        <form className="pure-form pure-form-stacked" onSubmit={this.handleSelected}>
          <h2>Filter By {this.props.label}</h2>
          <fieldset>
            {this.selectField}
          </fieldset>
          <fieldset>
            <SubmitButton
              title="Filter"
              text="Filter"
              loading={isEqual(this.state.value, this.state.initialValue)}
            />
          </fieldset>
        </form>
      </Modal>
    )
  }
}
